import { styled } from "@mui/material";

const PREFIX = "Header";

export const classes = {
  header: `${PREFIX}-header`,
  toolbar: `${PREFIX}-toolbar`,
  leftSection: `${PREFIX}-leftSection`,
  rightSection: `${PREFIX}-rightSection`,
  logo: `${PREFIX}-logo`,
};

export const AppBar = styled("div")(({ theme }) => ({
  [`&.${classes.header}`]: {
    backgroundColor: theme.palette.background.default,
    width: "100%",
    position: "relative",
    boxShadow: "0 1px 1px 0 rgba(0,0,0,.12)",
  },
  [`& .${classes.toolbar}`]: {
    display: "flex",
    justifyContent: "space-between",
    height: "80px",
    padding: "0px",
    maxWidth: "1600px",
    margin: "0 auto",
    backgroundColor: theme.palette.background.default,
    "@media (max-width: 600px)": {
      height: "60px",
    },
  },
  [`& .${classes.leftSection}`]: {
    display: "flex",
  },
  [`& .${classes.rightSection}`]: {
    display: "flex",
    minWidth: "130px",
    justifyContent: "flex-end",
    maxHeight: "50px",
  },
  [`& .${classes.logo}`]: {
    flexGrow: 1,
    color: theme.palette.background.default,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    marginTop: 10,
  },
}));
